import { Configuration, PopupRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_MSAL_CLIENT_ID ?? '',
    ...(process.env.NEXT_PUBLIC_MSAL_AUTHORITY && { authority: process.env.NEXT_PUBLIC_MSAL_AUTHORITY }),
    ...(process.env.NEXT_PUBLIC_MSAL_REDIRECT_URI && { redirectUri: process.env.NEXT_PUBLIC_MSAL_REDIRECT_URI }),
    ...(process.env.NEXT_PUBLIC_MSAL_POST_LOGOUT_REDIRECT_URI && { postLogoutRedirectUri: process.env.NEXT_PUBLIC_MSAL_POST_LOGOUT_REDIRECT_URI }),
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["email", "profile", "User.Read", "Sites.Manage.All"],
};
